/* eslint-disable */
import React, { Component } from 'react'
import { ScrollView, Text, KeyboardAvoidingView, View, Keyboard, Animated, TouchableOpacity, TouchableWithoutFeedback, Dimensions, StatusBar, Platform } from 'react-native'
import { connect } from 'react-redux'
import InputCell from "../Components/InputCell"
import FooterButton from "../Components/FooterButton"
import NavigationBar from "../Components/NavigationBar"
import { Images } from "../Themes"
import { KeyboardAwareScrollView, alertView, isIPhoneX } from '../Lib/utils'
import BadgeButton from '../Components/BadgeButton'
import { validateForget } from '../Components/ValidateComponent'
import UserActions from '../Redux/UserRedux'
import { Field, reduxForm, startSubmit } from 'redux-form';
import { SvgBackButton } from '../Components/SvgComponent/';

import BaseScreen from "./BaseScreen";
import { Fonts } from   '../Themes'
import styles from './Styles/ForgetPassScreenStyle'
import I18n from "i18n-js"

let { width: screenWidth, height: screenHeight } = Dimensions.get('window')

class ForgetPassScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: "",
    }
    this.keyboardHeight = new Animated.Value(0)
    this.belowKeyboardHeight = 0
  }

  componentDidMount() {
    // this.navigationBar.setLeftNavBarButtons([
    //  { onPress: this.onBackPress, type: 'back' },
    // ])
    this.keyboardWillShowListener = Keyboard.addListener('keyboardWillShow', this.keyboardWillShow.bind(this))
    this.keyboardWillHideListener = Keyboard.addListener('keyboardWillHide', this.keyboardWillHide.bind(this))
  }

  componentWillUnmount( ) {
    this.keyboardWillShowListener.remove( )
    this.keyboardWillHideListener.remove( )
  }

  keyboardWillShow = e => {
    Animated.timing( this.keyboardHeight, { toValue : e.endCoordinates.height + this.belowKeyboardHeight, duration : 333 }).start( )
  }

  keyboardWillHide = e => {
    Animated.timing( this.keyboardHeight, { toValue : 0, duration : 333 }).start( )
  }

  onBackPress = () => {
    this.props.navigation.goBack()
  }

  isValid = () => {
    return this.state.email
  }

  resetPass = (values) => {
    Keyboard.dismiss()
    console.log("ready to call startSubmit")
    // this is what is called, not props.resetPassword
    this.props.navigation.dispatch(startSubmit('ForgetForm'))
    console.log("did call startSubmit")
    // get us out of here otherwise we are stuck on web
    if (Platform.OS == 'web') this.onBackPress() 
    // the above dispatch doesnt seem to collect any response from server 
    // unless it is put in some redux state somewhere
    // return new Promise((resolve, reject) => {
    //   this.props.resetPassword({ ...values, resolve: this.resetPassSuccess, reject })
    // });
  }

  resetPassSuccess = () => {
    alertView(I18n.t("login.resetEmailed"), "", () => {
      this.onBackPress()
    })
  }

  resetPassFailure = () => {
    alertView(I18n.t("login.resetFailed"))
  }

  render() {
    const keyboardHgt     = 0 + this.keyboardHeight.__getValue()
    const statusBarHeight = isIPhoneX() ? 30 : 20
    const scrollHeight    = screenHeight - statusBarHeight - keyboardHgt
    const headerFontSize   = isIPhoneX() ? 21 : 17
    const titleBottom      = isIPhoneX() ? 40 : 0
    const headerStyle     = {flexDirection: 'row', justifyContent: 'flex-start', paddingTop: 10, paddingLeft: 10, paddingRight: 10}
    const disabled = !this.isValid()
    const { submitting, handleSubmit } = this.props

    //console.log("handleSubmit = " + handleSubmit)

/*
        <View style={styles.statusBar} />
        <StatusBar translucent barStyle="light-content" />
        <NavigationBar title={I18n.t('login.forgotpass')} type={'black'} ref={(view) => { if (view) this.navigationBar = view }} />
*/
    return (
      <BaseScreen fullLoading={submitting}>
        <TouchableWithoutFeedback style={{flex: 1}}>
          <Animated.View keyboardShouldPersistTaps='always' style={{position: 'absolute', width: screenWidth, top: statusBarHeight, bottom: this.keyboardHeight}}>
            <ScrollView keyboardShouldPersistTaps='always' style={{}} contentContainerStyle={{flex: 1, flexDirection: 'column', justifyContent: 'space-between', height: scrollHeight}}>
              <View>
                <View style={headerStyle}>
                  <TouchableOpacity onPress={this.onBackPress} style={{width: '20%'}}>
                    <SvgBackButton />
                  </TouchableOpacity>
                  <Text style={{width: '60%', textAlign: 'center', fontSize: headerFontSize, fontFamily:Fonts.style.font.extraBold, marginBottom: titleBottom }}>{I18n.t('login.forgotpass')}</Text>
                </View>
                <Field name="email"
                  separator
                  autoCapitalize="none"
                  autoCorrect={false}
                  onBlur = {()=> new Promise((resolve, reject) => {
                    this.props.resetPassword({ email : this.state.email, resolve: this.resetPassSuccess, reject: this.resetPassFailure })
                  })}
                  onChange={(text) => {
                    this.setState({ email: text })
                  }}
                  placeholder={I18n.t("login.emailOrUsername")}
                  title={``}
                  value={this.state.email}
                  component={InputCell}
                />
              </View>
              <View style={{ marginVertical: 0 }}>
                <FooterButton
                  disabled={!this.isValid() || submitting}
                  onPress={Platform.OS == 'web' ? this.onBackPress : handleSubmit(this.resetPass)}
                  style={styles.footerButton}
                  title={I18n.t('signUp.requestReset')}
                />
              </View>
            </ScrollView>
          </Animated.View>
        </TouchableWithoutFeedback>
      </BaseScreen>
    )
  }
}

const mapStateToProps = state => ({ auth: state.auth })

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = dispatch => ({
  resetPassword: (data) => dispatch(UserActions.resetPassRequest(data)),
  startSubmit: (ForgetForm) => dispatch(startSubmit(ForgetForm))
})

const ForgetForm = reduxForm({
  form: 'ForgetForm',
  validate: validateForget
})(ForgetPassScreen)

export default connect(mapStateToProps, mapDispatchToProps)(ForgetForm)
